import React from 'react';
import classNames from 'classnames';
import Select from '../select';
import { ConfigContext } from '../config-provider';
import { isValidElement } from '../_util/reactNode';
import toArray from 'rc-util/lib/Children/toArray';
const { Option } = Select;
function isSelectOptionOrSelectOptGroup(child) {
    return (child
        && child.type
        && (child.type.isSelectOption || child.type.isSelectOptGroup));
}
const AutoComplete = (props, ref) => {
    const { prefixCls: customizePrefixCls, className, children } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('select', customizePrefixCls);
    const childNodes = toArray(children);
    // ============================= Input =============================
    let customizeInput;
    if (childNodes.length === 1
        && isValidElement(childNodes[0])
        && !isSelectOptionOrSelectOptGroup(childNodes[0])) {
        [customizeInput] = childNodes;
    }
    const getInputElement = customizeInput
        ? () => customizeInput
        : undefined;
    // ============================ Options ============================
    let optionChildren;
    if (childNodes.length && isSelectOptionOrSelectOptGroup(childNodes[0])) {
        optionChildren = children;
    }
    else {
        optionChildren = [];
    }
    return (<Select ref={ref} {...props} prefixCls={prefixCls} className={classNames(`${prefixCls}-auto-complete`, className)} mode={Select.SECRET_COMBOBOX_MODE_DO_NOT_USE} {...{
        getInputElement,
    }}>
            {optionChildren}
        </Select>);
};
const RefAutoComplete = React.forwardRef(AutoComplete);
RefAutoComplete.Option = Option;
export default RefAutoComplete;
// export default AutoComplete;
